/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import { ReturnItem } from '@/models/Return.model';
import Api from '@/services/api';

export default {

  create(params: { senderAddress: { contactPerson: string, phoneCell?: string, 
    email: string, companyName?: string, address1?: string, address2?: string, address3?: string, addressSuburb?: string, 
    addressCountry?: string, addressProvince?: string, postCode: string }, collectionDate: string, collectionTime: string, 
    specialInstructions: string, totalItems: number, returnItems: ReturnItem[] }) {
    return Api().post('/return/create', params);
  },

};
